module.exports = __webpack_public_path__ + "Server-Healthy.TentaclePassive.b67addeda2355aaae06ee96dce7f8ecb.hashedasset.svg";